import Cookies from 'js-cookie'

// const TokenKey = 'Admin-Token'

export function getToken (TokenKey) {
  return Cookies.get(TokenKey)
}

/**
 * js-cookie 未设置过期时间，默认情况下cookie有效期截止至用户退出浏览器。
 * @param token 设置的token
 * @returns {*}
 */
export function setToken (TokenKey, token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken (TokenKey) {
  return Cookies.remove(TokenKey)
}

/**
 * 截取jwttoken中段信息，转换为json数据
 * @param token
 * @return {*}
 */
export function getDataFromJwtToken (TokenKey) {
  const token = Cookies.get(TokenKey)
  if (!token) {
    return null
  }
  var data = token.split('.')[1]
  if (!data) {
    return null
  }
  const Base64 = require('js-base64').Base64
  return JSON.parse(Base64.decode(data))
}

/**
 * 判断过期时间
 * @returns {boolean}
 */
export function isTokenExpired (type) {
  const tokenObj = getDataFromJwtToken()
  let currentTime = new Date().getTime() / 1000
  if (type === 'ahead') {
    // 提前10分钟判断过期
    currentTime += 10 * 60
  }
  return tokenObj && currentTime > tokenObj.exp
}
